/*
 * @Author: your name
 * @Date: 2020-12-27 16:06:25
 * @LastEditTime: 2020-12-27 16:33:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Editu
 * @FilePath: /yunlizhi/货主端1.0/src/constants/rule.js
 */

export default {
    Name: {
        MAX_LENGTH: 30, // 最大长度
        RULES: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
        ]
    },
    Phone: {
        MAX_LENGTH: 16, // 最大长度
        RULES: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^\d{1,16}(-\d{1,16})*$/, message: '请输入正确的手机号', trigger: 'blur' },
        ]
    }
}
